module.exports = __webpack_public_path__ + "img/25-image-1@2x.af43cc0d.png";